import { StrictMode } from 'react'; import { createRoot } from 'react-dom/client'; import { App } from './app/App'; import { registerPwaUpdates } from './pwa/updateService'; import './styles/index.css';
createRoot(document.getElementById('root')!).render(<StrictMode><App/></StrictMode>);
if (import.meta.env.PROD) registerPwaUpdates();
